<template>
  <div class="d-flex">
    <label
      v-for="(option, index) in options"
      :key="index"
      class="custom-control custom-radio mr-4"
      :for="`${getOptionId(option)}-${uniqueId}`">
      <input
        type="radio"
        :id="`${getOptionId(option)}-${uniqueId}`"
        class="custom-control-input"
        :name="name"
        :value="option.value"
        v-model="selectedOption"
      />
      <div class="custom-control-label">
        <div class="align-items-center d-flex">
          <span :class="`radio-item__${option.label}`"></span
          ><span>{{ option.label }}</span>
        </div>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      selectedOption: this.value,
      uniqueId: this._uid
    };
  },
  methods: {
    getOptionId(option) {
      return `${this.name}-${option.value}`;
    }
  },
  watch: {
    selectedOption() {
      this.$emit("input", this.selectedOption);
    }
  }
};
</script>
